import chooseNextProperId from 'helpers/chooseNextProperId'
import prop from 'ramda/src/prop'
import assoc from 'ramda/src/assoc'

export default function duplicateCamera(state, action) {
  const { cameras } = state
  const { id, location, imagerId, lensIds, fixedLensIds } = action
  const newId = imagerId || chooseNextProperId(cameras.map(prop('id')))
  const camera = cameras.find(c => c.id === id)

  const newCamera = Object.assign({}, camera,
    {
      active: true,
      id: newId,
      name: `Camera ${cameras.filter(c => !c.imagerId).length + 1}`,
      location
    },
    lensIds && { lensIds },
    fixedLensIds && fixedLensIds.length > 0 && { fixedLensIds }
  )

  return Object.assign({}, state, {
    currentEntity: {
      type: 'camera',
      id: newId
    },
    cameras: [
      ...cameras.map(assoc('active', false)),
      newCamera
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/duplicateCamera.js